import { computed, ref } from 'vue';
import type { Country, Currency, Timezone } from '@/services/models';
import { saveUserDataToLocalStorage } from '@/services/localStorage-users-data';
import { useStore } from '@/store';

export const createMainDataModule = () => {
  const isLoading = ref(false);
  const panelBlocked = ref(false);
  const alertsCount = ref(0);
  const currencyList = ref<Currency[]>([]);
  const countryList = ref<Country[]>([]);
  const timezoneList = ref<Timezone[]>([]);
  const customEvents = ref<Record<string, unknown>>({});
  const bookmarks = ref<Bemob.Bookmark[]>([]);

  const countryListPlusGlobal = computed(() => [
    { code: '', id: 0, name: 'Global' },
    ...countryList.value,
  ]);

  const persistBookmarks = () => {
    saveUserDataToLocalStorage(useStore().user.id, { bookmarks: bookmarks.value });
  };

  const setLoading = (value: boolean) => {
    isLoading.value = value;
  };

  const setPanelBlocked = (value: boolean) => {
    panelBlocked.value = value;
  };

  const setCurrencyList = (value: Currency[]) => {
    currencyList.value = value;
  };

  const setCountryList = (value: Country[]) => {
    countryList.value = value;
  };

  const setTimezoneList = (value: Timezone[]) => {
    timezoneList.value = value;
  };

  const setBookmarks = (value: Bemob.Bookmark[]) => {
    bookmarks.value = value;
  };

  const setCustomEvents = (value: Record<string, unknown>) => {
    customEvents.value = value;
  };

  const addBookmark = (bookmark: Bemob.Bookmark) => {
    bookmarks.value = bookmarks.value.concat([bookmark]);
    persistBookmarks();
  };

  const editBookmark = (index: number, bookmark: Bemob.Bookmark) => {
    const updatedBookmarks = [...bookmarks.value];
    updatedBookmarks[index] = bookmark;
    bookmarks.value = updatedBookmarks;
    persistBookmarks();
  };

  const removeBookmark = (index: number) => {
    bookmarks.value = bookmarks.value.filter((item, bookmarkIndex) => bookmarkIndex !== index);
    persistBookmarks();
  };

  const reset = () => {
    currencyList.value = [];
    countryList.value = [];
    timezoneList.value = [];
    customEvents.value = {};
    bookmarks.value = [];
    isLoading.value = false;
    panelBlocked.value = false;
    alertsCount.value = 0;
  };

  return {
    state: {
      isLoading,
      panelBlocked,
      alertsCount,
      currencyList,
      countryList,
      timezoneList,
      customEvents,
      bookmarks,
      countryListPlusGlobal,
      setLoading,
      setPanelBlocked,
      setCurrencyList,
      setCountryList,
      setTimezoneList,
      setCustomEvents,
      setBookmarks,
      addBookmark,
      editBookmark,
      removeBookmark,
    },
    reset,
  };
};
